import { BaseModule, EventBus } from '@mc/tangram-core'
import billionTab from '@/images/cms/goods/billion-tab.png'
const billionCmsCode = 'mc_billion_goods_group'

const enumGoodsLayoutType = {
  single: 'sole',
  double: 'double',
  triple: 'tris',
  scroll: 'scroll'
}

const factors = {
  [enumGoodsLayoutType.single]: 1,
  [enumGoodsLayoutType.double]: 2,
  [enumGoodsLayoutType.triple]: 3,
  [enumGoodsLayoutType.scroll]: Infinity
}

const getGoodWidth = (factor, contentWidth, elementMargin) => {
  if (factor === Infinity) {
    return Math.ceil((contentWidth - elementMargin * 3) / 3.5)
  } else {
    const margins = elementMargin * (factor - 1)
    return (contentWidth - margins) / factor
  }
}

const goodsProcessor = (
  module,
  item,
  { layoutType, contentWidth, elementMargin }
) => {
  const ssus = item.rows
  const factor = factors[layoutType]
  const goodWidth = getGoodWidth(factor, contentWidth, elementMargin)
  const goods = ssus.map(ssuItem => {
    const ssu = Object.assign({}, ssuItem, {
      ssuInfo: ssuItem.ssuList[0]
    })
    return {
      goodStyle: module.formatStyle({
        width: module.valueCalc(goodWidth)
      }),
      goodWidth: factor === 1 ? 80 : parseInt(module.valueCalc(goodWidth)),
      ssu
    }
  })
  if (factor === Infinity) {
    return [goods]
  } else {
    const results = []
    for (let i = 0; i < goods.length; i += factor) {
      results.push(goods.slice(i, i + factor))
    }
    return results
  }
}

export class Goods extends BaseModule {
  id = ''
  name = 'goods'
  isGroup = false
  layoutType = enumGoodsLayoutType.scroll

  events = {
    addCart: 'add-cart',
    subscribe: 'subscribe'
  }

  EventBus = new EventBus()

  constructor(options) {
    super(options)
    this.id = options.id
    this.layoutType = options.layoutType
    this.isGroup = options.isGoodsGroup
    this.isBillionGoodsGroup = options.isBillionGoodsGroup
    this.isBillionCmsCode = options?.rawOptions?.code === billionCmsCode
    this.performanceType = options?.rawOptions?.performanceType
    this.tabStyle = options.tabStyle = {}
    const tabs = options.data
      .map(item => item.meta_info)
      .filter(item => !!item.name.trim())
    // 十亿补贴样式
    const titleBgImg = options?.rawOptions?.style?.titleBgImg?.img_url
      ? options?.rawOptions?.style?.titleBgImg?.img_url
      : billionTab
    const titleBgImgHeight = options?.rawOptions?.style?.titleBgImg?.height
      ? options?.rawOptions?.style?.titleBgImg?.height
      : 64
    const titleColor = options?.rawOptions?.style?.titleColor
      ? options?.rawOptions?.style?.titleColor
      : '#834B00'
    const tabCurrentStyle = {
      backgroundImage: `url(${titleBgImg})`,
      color: titleColor,
      height: this.valueCalc(titleBgImgHeight),
      lineHeight: this.valueCalc(titleBgImgHeight)
    }
    this.tabCurrentStyle = tabCurrentStyle

    // 普通样式
    this.tabStyle = {
      titleBgColor: options?.rawOptions?.style?.titleBgColor || '',
      selectedColor: options?.rawOptions?.style?.selectedColor || '',
      unselectTitleColor: options?.rawOptions?.style?.unselectTitleColor || '',
      selectedTitleColor: options?.rawOptions?.style?.selectedTitleColor || ''
    }

    const goods = options.data.map(item =>
      goodsProcessor(this, item, {
        layoutType: this.layoutType,
        contentWidth: this.contentWidth,
        elementMargin: this.elementMargin
      })
    )

    this.data = {
      tabs,
      goods
    }
    this.EventBus.on(this.events.addCart, data => {
      this.addCart(data)
    })
    this.EventBus.on(this.events.subscribe, data => {
      this.subscribe(data)
    })
  }

  async addCart() {}
  async subscribe() {}

  render() {
    const {
      id,
      pageId,
      name,
      isGroup,
      isBillionGoodsGroup,
      isBillionCmsCode,
      containerStyle,
      layoutType,
      elementMargin,
      data,
      events,
      globalEvents,
      tabCurrentStyle,
      performanceType,
      tabStyle
    } = this
    return {
      id,
      pageId,
      renderIdentifier: name,
      containerStyle,
      isGroup,
      isBillionGoodsGroup,
      isBillionCmsCode,
      layoutType,
      data,
      elementMargin,
      factor: factors[layoutType],
      elementMarginCalculated: this.valueCalc(elementMargin),
      events,
      globalEvents,
      tabCurrentStyle,
      tabStyle,
      performanceType
    }
  }
}
